import { useCallback, useEffect, useState } from 'react';
import { api } from './lib/api';
import type { Me } from './lib/api';
import { Login } from './pages/Login';
import { PasswordChange } from './pages/PasswordChange';
import { Shell } from './components/Shell';
import { ClientShell } from './components/ClientShell';

export default function App() {
  // undefined = checking session, null = signed out
  const [me, setMe] = useState<Me | null | undefined>(undefined);

  const load = useCallback(() => {
    api<Me>('/api/me').then(setMe).catch(() => setMe(null));
  }, []);
  useEffect(load, [load]);

  const logout = async () => {
    await api('/api/auth/logout', { method: 'POST' }).catch(() => undefined);
    setMe(null);
  };

  if (me === undefined) {
    return <div className="login-wrap"><div className="muted">Loading Praxis…</div></div>;
  }
  if (me === null) return <Login onLogin={load} />;
  if (me.user.must_change_password) return <PasswordChange me={me} onDone={load} onLogout={logout} />;
  if (me.role === 'client') return <ClientShell me={me} onLogout={logout} />;
  return <Shell me={me} onLogout={logout} />;
}
